import axios from 'axios'

import { getCookie, removeCookie, removeSession } from '@/lib/utils'

const api = axios.create({
  baseURL: `${process.env.NEXT_PUBLIC_ENTRYPOINT}`
})

api.interceptors.request.use(
  config => {
    const { token } = getCookie('eskolare-shop-token') || {}

    if (
      token &&
      (!config.headers?.Authorization || !config.headers?.authorization) &&
      config.headers
    ) {
      config.headers.Authorization = `Token ${token}`
    }

    return config
  },
  error => Promise.reject(error)
)

api.interceptors.response.use(
  function (response) {
    return response
  },
  function (error) {
    if (error.response?.status === 401) {
      removeCookie('eskolare-shop-token')
      removeSession('stuid')
    }
    return Promise.reject(error)
  }
)

export default api
